<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("stocks.modulesbtn") }}</span>
    </v-tooltip>
    <base-material-card
      icon="mdi-clipboard-list"
      color="primary"
      inline
      class="px-5 py-3 my-12"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          {{ $t("stocks.Inventory") }}
        </div>
      </template>

      <v-data-table
        :headers="headers"
        :items="stocks"
        sort-by="name"
        :search="search"
        @click:row="goToProfile"
        class="elevation-0 my-12"
        :footer-props="{
          itemsPerPageText: $t('repairList.itemsPerPage'),
          itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
        }"
      >
        <template v-slot:top>
          <div
            :class="
              $vuetify.breakpoint.mdAndUp
                ? 'd-flex align-center'
                : 'd-flex flex-column'
            "
          >
            <v-text-field
              v-model="search"
              :label="$t('stocks.search')"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              v-if="$store.getters['auth/adminAndUp']"
              color="primary"
              dark
              class="mr-2 mb-2"
              to="/stocks/units"
            >
              {{ $t("stocks.newUnits") }}
            </v-btn>
            <v-btn
              color="primary"
              dark
              class="mr-2 mb-2"
              v-if="$store.getters['auth/adminAndUp']"
              to="/stocks/categories"
            >
              {{ $t("stocks.newCategories") }}
            </v-btn>
            <v-btn
              color="primary"
              dark
              class="mr-2 mb-2"
              @click="$router.push({ name: 'New/Stocks' })"
            >
              {{ $t("stocks.newItem") }}
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ item.date | formatDate }}
        </template>
        <template v-slot:[`item.category`]="{ item }">
          <template>
            <div class="d-flex flex-column">
              <v-chip
                :color="category.color"
                small
                dark
                class="my-1"
                v-for="(category, index) in item.category"
                :key="index"
              >
                {{ category.name }}
              </v-chip>
            </div>
          </template>
        </template>
        <template v-slot:[`item.subtotal`]="{ item }">
          {{ parseFloat(item.partialValue * item.quanty).toFixed(2) }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "Stocks",
  data() {
    return {
      tab: null,
      selected: [],
      items: ["PERFIL", "ITEMS"],
      search: "",
      headers: [
        { text: this.$t("stocks.sku"), value: "sku" },
        { text: this.$t("stocks.name"), value: "name" },
        { text: this.$t("stocks.date"), value: "date" },
        { text: this.$t("stocks.quantity"), value: "quanty" },
        { text: this.$t("stocks.unit"), value: "unit" },
        { text: this.$t("stocks.category"), value: "category" },
        { text: this.$t("stocks.unitValue"), value: "partialValue" },
        { text: this.$t("stocks.subtotal"), value: "subtotal" },
        { text: "", value: "actions", sortable: false }
      ]
    };
  },

  computed: {
    ...mapState("stocks", ["stocks", "categories", "units"])
  },
  async created() {
    await this.$store.dispatch("stocks/bindStocks");
  },
  methods: {
    goToProfile(item) {
      this.$router.push({
        name: "StocksProfile",
        params: { id: item.id }
      });
    }
  }
};
</script>
